import { render } from "./Entity.vue?vue&type=template&id=3ab0bcde&ts=true"
import script from "./Entity.vue?vue&type=script&lang=ts"
export * from "./Entity.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\agent\\_work\\39\\s\\Infosit.Cms.Web.v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__